import React from "react";
import { ITkBorderProps } from "../../../type/componentsType/TkBorderProps";
import { Box } from "@mui/material";
import "./_style.scss";

/**
 * TkBorderコンポーネントは、ボーダーを表示するためのコンポーネントです。
 *
 * @param className クラス名
 * @param children 子要素
 * @param bold ボーダーを太くするかどうか
 */
const TkBorder: React.FC<ITkBorderProps> = (props) => {
  const { className, children, bold = false } = props;

  return (
    <Box
      data-testid="tkBorder"
      className={`tkBorder ${className} ${bold && "tkBorderBold"}`}
    >
      {children}
    </Box>
  );
};

export default TkBorder;
